'use client';
import { useRouter } from 'next/navigation';
import React from 'react';
import { LoginUserForm } from './LoginUserForm';

const authenticationInverseActionContent = {
  login: {
    destination: 'Inicia sesión',
    question: '¿Ya tienes una cuenta?',
  },
  register: {
    destination: 'Regístrate',
    question: '¿No tienes una cuenta?',
  },
};

export const Login = () => {
  const router = useRouter();

  return (
    <LoginUserForm
      inverseAction={{
        type: 'path',
        path: '/register',
        ...authenticationInverseActionContent.register,
      }}
      onDone={() => router.push('/')}
    />
  );
};
